<div class="return-wrap" [class.disabled]="disabled">
  <!-- Search / add -->
  <div class="row search-row" #searchWrap>
    <!-- Reason selector for batching -->
    <div class="reason-select">
      <label>Reason</label>
      <select class="pretty-select"
              [disabled]="disabled"
              [(ngModel)]="selectedReason">
        <option *ngFor="let r of reasons" [value]="r">{{ r }}</option>
      </select>
    </div>

    <input
      type="text"
      class="search"
      placeholder="Search product by name or code…"
      [ngModel]="searchText"
      (ngModelChange)="onSearchChange($event)"
      (focus)="openSearch()"
    />

    <!-- Dropdown results -->
    <div
      class="results"
      *ngIf="isSearchOpen && filteredProducts.length"
    >
      <button
        class="result"
        type="button"
        *ngFor="let p of filteredProducts; trackBy: trackByProduct"
        (click)="addProduct(p)"
      >
        <div class="line1">{{ p.name }}</div>
        <div class="line2">
          <span class="code" *ngIf="p.default_code">#{{ p.default_code }}</span>
          <span class="price">₹{{ getPriceForProduct(p) | number: '1.2-2' }}</span>
          
          <span class="price">(MRP: ₹{{ p.mrp | number: '1.2-2' }})</span>
        </div>
      </button>
    </div>

    <div
      class="nores"
      *ngIf="isSearchOpen && searchText && !filteredProducts.length"
    >
      No products
    </div>
  </div>

  <!-- Grid -->
  <div class="table-wrap" *ngIf="returnItems.length; else empty">
    <table>
      <thead>
        <tr>
          <th style="width: 44px;">#</th>
          <th>Product</th>
          <th style="width: 110px;">Qty</th>
          <th style="width: 150px;">Price</th>
          <th style="width: 150px;">Total</th>
          <th style="width: 200px;">Reason</th>
          <th style="width: 80px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of returnItems; let i = index; trackBy: trackByReturnItem" 
            (dblclick)="!disabled && openEditDialog(row)" 
            [class.readonly-row]="disabled"
            class="return-item-row">
          <td>{{ i + 1 }}</td>
          <td>
            <div class="pname">{{ row.name }}</div>
            <div class="pmeta" *ngIf="row.code">#{{ row.code }}</div>
          </td>
          <td class="num">{{ row.quantity }}</td>
          <td class="num">₹ {{ row.price | number:'1.2-2' }}</td>
          <td class="num">₹ {{ (row.quantity * row.price) | number:'1.2-2' }}</td>
          <td>{{ row.reason }}</td>
          <td>
            <button type="button"
                    class="icon-btn danger"
                    (click)="removeItem(row)"
                    [disabled]="disabled">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="grand">
          <td colspan="4" class="right">Return Amount</td>
          <td class="num">₹ {{ total() | number:'1.2-2' }}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <ng-template #empty>
    <div class="empty">No items in return. Search above to add products.</div>
  </ng-template>

  <!-- Previous Returns Section -->
  <div class="previous-returns-section" *ngIf="customer?.id">
    <div class="section-header" (click)="togglePreviousReturns()">
      <h3>Previous Returns</h3>
      <mat-icon class="expand-icon" [class.expanded]="showPreviousReturns">
        {{ showPreviousReturns ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
    
    <div class="previous-returns-content" *ngIf="showPreviousReturns">
      <div class="loading" *ngIf="isLoadingPreviousReturns">
        Loading previous returns...
      </div>
      
      <div class="no-returns" *ngIf="!isLoadingPreviousReturns && previousReturns.length === 0">
        No previous returns found for this customer.
      </div>
      
      <div class="table-wrap" *ngIf="!isLoadingPreviousReturns && previousReturns.length > 0">
        <div class="previous-returns-list">
          <div class="return-group" *ngFor="let return of previousReturns; trackBy: trackByReturnId">
            <!-- Return Header -->
            <div class="return-header">
              <div class="return-info">
                <span class="return-name">{{ return.name }}</span>
                <span class="return-date">{{ return.date | date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="return-invoice" *ngIf="return.invoiceNumber">Invoice: {{ return.invoiceNumber }}</span>
                <span class="return-status" [class.confirmed]="return.state === 'confirmed'" [class.draft]="return.state === 'draft'">
                  {{ return.state | titlecase }}
                </span>
              </div>
              <div class="return-total">
                Total: ₹ {{ return.amountTotal | number:'1.2-2' }}
              </div>
            </div>
            
            <!-- Return Line Items -->
            <table class="previous-returns-table">
              <thead>
                <tr>
                  <th style="width: 44px;">#</th>
                  <th>Product</th>
                  <th style="width: 110px;">Qty</th>
                  <th style="width: 150px;">Price</th>
                  <th style="width: 150px;">Total</th>
                  <th style="width: 200px;">Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let line of return.lines; let i = index; trackBy: trackByReturnLineId">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <div class="pname">{{ line.productName }}</div>
                    <div class="pmeta" *ngIf="line.productId">#{{ line.productId }}</div>
                  </td>
                  <td class="num">{{ line.quantity }}</td>
                  <td class="num">₹ {{ line.priceUnit | number:'1.2-2' }}</td>
                  <td class="num">₹ {{ line.subtotal | number:'1.2-2' }}</td>
                  <td>{{ line.reason || 'N/A' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="actions">
    <button type="button" class="btn outline" (click)="clearAll()" [disabled]="disabled || !returnItems.length">
      Clear
    </button>
    <button type="button" class="btn primary" (click)="submit()" [disabled]="disabled || !returnItems.length">
      Create Credit Note
    </button>
  </div>
</div>
